<script lang="ts">
	import { replaceVariables } from '../replaceVariables/replaceVariables'
	import StructuredTextCustomBlock from './StructuredTextCustomBlock.svelte'
	import type { BlockComponent, StructuredTextType } from './structuredText'
	import { render as renderStructuredText } from 'datocms-structured-text-to-html-string'

	interface Props {
		structuredText: StructuredTextType
		variables?: Record<string, string>
		components?: BlockComponent[]
	}

	let { structuredText, variables = {}, components = [] }: Props = $props()
</script>

{#each structuredText.value.document.children as children, index (index)}
	{#if children.type !== 'block'}
		<!-- eslint-disable-next-line svelte/no-at-html-tags -->
		{@html replaceVariables(renderStructuredText(children), variables)}
	{:else}
		{@const item = structuredText.blocks?.find((block) => block.id === children.item)}
		{#if item}
			<StructuredTextCustomBlock {components} {item} {variables} />
		{/if}
	{/if}
{/each}
